// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"a5-z","dimensionLabel":"b5-z","styleChooserControlWrapper":"c5-z","styleChooserControl":"d5-z","disabled":"e5-z","giftCard":"f5-z","styleChooserText":"g5-z"};